// Utility helpers for filtering transactions by time periods
// Periods supported: week, month, lastMonth, year, all

const MS_IN_DAY = 24 * 60 * 60 * 1000;

export function filterTransactionsByPeriod(transactions, period) {
  if (!Array.isArray(transactions) || transactions.length === 0) return [];
  if (!period || period === 'all') return [...transactions].sort((a,b)=> new Date(b.date) - new Date(a.date));

  const now = new Date();
  const startOfToday = new Date(now.getFullYear(), now.getMonth(), now.getDate());

  let startDate;
  let endDate = new Date(startOfToday.getTime() + MS_IN_DAY); // exclusive end

  switch (period) {
    case 'week': {
      // last 7 days including today
      startDate = new Date(startOfToday.getTime() - 6 * MS_IN_DAY);
      break;
    }
    case 'month': {
      startDate = new Date(now.getFullYear(), now.getMonth(), 1);
      break;
    }
    case 'lastMonth': {
      startDate = new Date(now.getFullYear(), now.getMonth() - 1, 1);
      endDate = new Date(now.getFullYear(), now.getMonth(), 1);
      break;
    }
    case 'year': {
      startDate = new Date(now.getFullYear(), 0, 1);
      break;
    }
    default:
      return [...transactions].sort((a,b)=> new Date(b.date) - new Date(a.date));
  }

  return transactions.filter(t => {
    const d = new Date(t.date);
    return d >= startDate && d < endDate;
  }).sort((a,b)=> new Date(b.date) - new Date(a.date));
}

export function getPeriodLabel(period) {
  switch (period) {
    case 'week': return 'This Week';
    case 'month': return 'This Month';
    case 'lastMonth': return 'Last Month';
    case 'year': return 'This Year';
    case 'all':
    default: return 'All Time';
  }
}

export function groupByMonth(transactions) {
  const map = new Map();
  for (const t of transactions) {
    const d = new Date(t.date);
    const key = `${d.getFullYear()}-${String(d.getMonth()+1).padStart(2,'0')}`;
    const prev = map.get(key) || { income: 0, expense: 0 };
    if (t.amount >= 0) prev.income += t.amount; else prev.expense += Math.abs(t.amount);
    map.set(key, prev);
  }
  return Array.from(map.entries()).sort(([a],[b])=> a.localeCompare(b)).map(([month, totals]) => ({ month, ...totals }));
}

const dateFilters = { filterTransactionsByPeriod, getPeriodLabel, groupByMonth };
export default dateFilters;
